import { render, staticRenderFns } from "./lamsRegLegalAdviserApproval.vue?vue&type=template&id=0f9c6b62&scoped=true&"
import script from "./lamsRegLegalAdviserApproval.vue?vue&type=script&lang=js&"
export * from "./lamsRegLegalAdviserApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c6b62",
  null
  
)

export default component.exports